import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { MessageEndpointLinkContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({ providedIn: 'root' })
export class MessageEndpointLinkService extends BaseApiTemplateService<MessageEndpointLinkContainer> {

  constructor(private http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'message-endpoint-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'message-endpoint-link';
    this.httpClient = http;
  }

}
